import { render, staticRenderFns } from "./epb-alert.component.vue?vue&type=template&id=1423381e&scoped=true"
import script from "./epb-alert.component.vue?vue&type=script&lang=ts"
export * from "./epb-alert.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-alert.component.vue?vue&type=style&index=0&id=1423381e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423381e",
  null
  
)

export default component.exports